const MenuItemSeparator = () => {
  return (
    <li className="kt-menu__separator">
      <span />
    </li>
  );
};

export default MenuItemSeparator;
